import type { SvgIconProps } from '@lokalise/ui/icons/SvgIcon';
import SvgIcon from '@lokalise/ui/icons/SvgIcon';
import { Path, Rect } from '@lokalise/ui/icons/styles';

const CheckboxCheckedFilled = ({ ...props }: SvgIconProps) => (
    <SvgIcon {...props}>
        <Rect x="3" y="3" width="14" height="14" rx="2" />
        <Path
            d="M8.66078 11.7443L6.62399 9.69497L6 10.3228L8.66078 13L14 7.62784L13.376 7L8.66078 11.7443Z"
            fill="content.white"
        />
    </SvgIcon>
);

export default CheckboxCheckedFilled;
